(() => {
  const storageKey = "andersondev-theme";
  const root = document.documentElement;
  const button = document.querySelector("[data-theme-toggle]");
  const label = document.querySelector("[data-theme-toggle-label]");

  const getStoredTheme = () => localStorage.getItem(storageKey);
  const getSystemTheme = () => window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  const getTheme = () => getStoredTheme() || getSystemTheme();

  const setTheme = (theme) => {
    root.setAttribute("data-theme", theme);
    if (label) label.textContent = theme === "dark" ? "Dark" : "Light";
  };

  setTheme(getTheme());

  if (!button) return;

  button.addEventListener("click", () => {
    const nextTheme = root.getAttribute("data-theme") === "dark" ? "light" : "dark";
    localStorage.setItem(storageKey, nextTheme);
    setTheme(nextTheme);
  });
})();
